<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center" v-if="!success">
        <b-col md="8">
          <b-card-group>            
            <b-card no-body class="p-4">
              <b-card-body>
                <h4 class="float-right"><b>Paso 1/3</b></h4><br/><br/>
                <h3>
                  Recuperar Contraseña
                  <br />
                  <small class="text-muted">Recibirá un mail con los pasos a seguir</small>
                </h3>
                <p class="text-muted">Ingrese su código de productor u organizador (agente)</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="icon-user"></i>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="number"
                    class="form-control"
                    placeholder="Código de productor u organizador (agente)"
                    autocomplete="off"
                    v-model="payload.cod_agente"
                    @blur="$v.payload.cod_agente.$touch"
                    :state="$v.payload.cod_agente.$dirty ? !$v.payload.cod_agente.$invalid : null"
                  />
                </b-input-group>
                <b-row>
                  <b-col class="text-right">
                    <b-button variant="link" to="/login" class="px-4 btn-action ">
                      Cancelar
                      <i class="fa fa-cancel"></i>
                    </b-button>
                    <b-button variant="primary" class="px-4 btn-action " @click="sendEmail()">
                      <i class="fa fa-check"></i> Aceptar
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <EmailConfirmation :emailagente="this.emailAgente" :payload="this.payload" v-else></EmailConfirmation>      
    </div>
  </div>
</template>

<script>
import { required, numeric } from 'vuelidate/lib/validators';
import EmailConfirmation from './EmailConfirmation.vue';
export default {
  components: { EmailConfirmation },
  name: 'PasswordEmailPage',
  data() {
    return {      
      success: false,
      emailAgente: '',
      payload: {
          cod_agente: '',
          email: '',
      }
    };
  },
  validations: {
    payload:{
      cod_agente: { required, numeric }
    }
  },
  methods: {
    sendEmail: async function() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error('El usuario ingresado es incorrecto.');
        return null;
      }

      const loader = this.$loading.show();

      await this.$api
        .post('auth/password/email', this.payload)
        .then(res => {          
          if (res.data.status_code == 200){
             this.emailAgente = res.data.email; 
             this.success = true
          }          
        })
        .catch((e) => {
          ////console.log(e.response.data.message);
          this.$toast.error(
              e.response.data.message,
              'Error'
          );
        });

      loader.hide();
    }
  }
};
</script>



<style scoped>
@media (max-width: 768px) {
  .btn-action {
    width: 100%;

  }
}
</style>